const megaData = {
    "Undersink Systems": {
        link: "/collections/undersink-water-filter-systems",
        img: "https://cdn.shopify.com/s/files/1/0571/9254/6444/files/Undersink_Systems_1.png?v=1767943528",
        text: "",
        details: {
            intro: "Compact, high-performance filtration units designed to deliver clean, great-tasting water straight from your kitchen tap. Ideal for families, renters, and offices.",
            features: [
                "Removes chlorine, sediment, and heavy metals",
                "Fits neatly under any standard kitchen sink",
                "Low-maintenance with long-life filters"
            ]
        }
    },
    "Inline Undersink Systems": {
        link: "/collections/inline-under-sink",
        img: "https://cdn.shopify.com/s/files/1/0571/9254/6444/files/Inline_Undersink_Systems_1.png?v=1767943519",
        text: "",
        details: {
            intro: "Simple, efficient inline filtration that installs directly into your existing tap or appliance line. Perfect when space is limited.",
            features: [
                "Slim and unobtrusive",
                "Quick installation",
                "Improves taste and reduces impurities"
            ]
        }
    },
    "Reverse Osmosis Systems": {
        link: "/collections/reverse-osmosis-water-filters",
        img: "https://cdn.shopify.com/s/files/1/0571/9254/6444/files/Reverse_Osmosis_Systems_1.png?v=1767943528",
        text: "",
        details: {
            intro: "Advanced multi-stage purification for the highest level of water purity. Removes dissolved solids, fluoride, and contaminants other filters can’t.",
            features: [
                "Produces exceptionally pure water",
                "Multi-stage filtration",
                "Ideal for sensitive needs (aquariums, babies, coffee machines)"
            ]
        }
    },
    "Whole House Systems": {
        link: "/collections/whole-house-water-filter",
        img: "https://cdn.shopify.com/s/files/1/0571/9254/6444/files/Whole_House_Systems_1.png?v=1767943528",
        text: "",
        details: {
            intro: "High-capacity systems that filter water at the point of entry, giving you clean, safe water from every tap and shower in your home.",
            features: [
                "Protects plumbing and appliances",
                "Reduces chlorine for softer showers",
                "Handles high flow rates"
            ]
        }
    },
    "MQ1": {
        link: "/products/mq1-under-sink-filter-system",
        img: "https://cdn.shopify.com/s/files/1/0571/9254/6444/files/MQ1_System.jpg?v=1750297468",
        text: "",
        details: {
        intro: "Micron MQ1 is a compact, entry level two-stage under sink filtration system with a 2-in-1 cartridge and dedicated faucet, delivering great tasting water with easy quick-twist filter changes at an affordable price.",
         features: [
            ]
        }
    },
    "MQ2": {
        link: "/products/mq2-single-under-sink-system",
        img: "https://cdn.shopify.com/s/files/1/0571/9254/6444/files/MQ2_System.jpg?v=1750297397",
        text: "",
        details: {
        intro: "Micron MQ2 is a compact dual stage under sink filtration system with a quick-change cartridge and chrome high loop faucet, reducing chlorine, heavy metals and harmful chemicals while retaining essential minerals for great tasting water.",
         features: [
            ]
        }
    },
    "MQ3": {
        link: "/products/mq3-triple-under-sink-system",
        img: "https://www.micronwaterfilters.com.au/cdn/shop/files/MQ3_System_249e7f21-f93e-4cc3-87f8-07e7350ce486.jpg?v=1750298072",
        text: "",
        details: {
        intro: "Micron MQ3 Triple Under Sink is a premium three stage filtration system with quick-change cartridges, combining sediment and double carbon filtration to reduce chemicals, heavy metals and particles for exceptional tasting water.",
         features: [
            ]
        }
    },
    "MX Series": {
        link: "/collections/mx-series",
        img: "https://www.micronwaterfilters.com.au/cdn/shop/files/mx1-image-2.jpg?v=1733702029",
        text: "",
        details: {
        intro: "MX Series inline underbench filtration systems connect directly to your existing tap or appliance line, offering effective reduction of sediment, chlorine and impurities in a space-saving design with simple installation.",
         features: [ 
            ]
        }
    },
    "MB Series": {
        link: "/collections/mb-series",
        img: "https://www.micronwaterfilters.com.au/cdn/shop/files/MB3-0781.jpg?v=1749001731",
        text: "",
        details: {
        intro: "MB Series advanced multi-stage underbench filtration systems use enhanced media to reduce sediment, chlorine, VOCs and other contaminants, delivering cleaner, better tasting water on demand with quick-change cartridges.",
         features: [  
            ]
        }
    },
    "Undersink": {
        link: "/collections/undersink-reverse-osmosis-filter-system",
        img: "https://www.micronwaterfilters.com.au/cdn/shop/files/mr-302b-square.jpg?v=1745279071",
        text: "",
        details: {
        intro: "Undersink water filtration systems provide clean, great tasting drinking water directly from your kitchen tap, using discreet underbench installation to save space while improving water quality for everyday use.",
         features: [
            ]
        }
    },
    "Countertop": {
        link: "/collections/countertop-reverse-osmosis-systems",
        img: "https://www.micronwaterfilters.com.au/cdn/shop/files/countertop-302-2.jpg?v=1731465096",
        text: "",
        details: {
        intro: "Countertop water filtration systems sit neatly on your bench to deliver clean, great tasting drinking water without permanent installation, making them ideal for rentals, compact kitchens or portable use.",
         features: [ 
            ]
        }
    },
    "Commercial Standard": {
        link: "/products/mwf-cro-600gf5",
        img: "https://www.micronwaterfilters.com.au/cdn/shop/files/MWF-CRO-600GF5_9155c7e7-ff4a-44bc-af80-f5df92c32645.jpg?v=1737534483",
        text: "",
        details: {
        intro: "Commercial Reverse Osmosis systems are designed for high demand environments, delivering large volumes of purified water with consistent quality, advanced monitoring and reliable performance for hospitality, healthcare and commercial applications.",
         features: [ 
            ]
        }
    },
    "Commercial Dental": {
        link: "/products/dental-ro-600g-system-with-ro-152-tank",
        img: "https://www.micronwaterfilters.com.au/cdn/shop/files/MWF-CRO-600GF5D5.jpg?v=1737534581&width=720",
        text: "",
        details: {
        intro: "Commercial Dental reverse osmosis systems are purpose built to deliver consistently purified water for dental practices, supporting sensitive equipment, patient procedures and daily operations with reliable performance and low maintenance operation.",
         features: [
            ]
        }
    },
    "20' Whole House System (300 Series)": {
        link: "/collections/20-whole-house-system-300-series",
        img: "https://cdn.shopify.com/s/files/1/0571/9254/6444/files/20_WH_System_300.jpg?v=1773883647",
        text: "",
        details: {
        intro: "High-performance whole house filtration designed for larger homes and higher water usage. Delivers cleaner water from every tap while protecting plumbing and appliances.",
         features: [
            ]
        }
    },
    "20' Whole House System (200 Series)": {
        link: "/collections/20-whole-house-system-200-series",
        img: "https://cdn.shopify.com/s/files/1/0571/9254/6444/files/20_WH_System_200.jpg?v=1773883647",
        text: "",
        details: {
        intro: "Reliable, everyday filtration for medium to large homes. Reduces chlorine and common contaminants for better water quality throughout your entire home.",
         features: [
            ]
        }
    },
    "10' Whole House System (200 Series)": {
        link: "/collections/10-whole-house-system-200-series",
        img: "https://cdn.shopify.com/s/files/1/0571/9254/6444/files/10_WH_System_200.jpg?v=1773883646",
        text: "",
        details: {
        intro: "Compact and efficient filtration for smaller households. Improves water quality at every tap while maintaining strong flow and performance.",
         features: [
            ]
        }
    },
    "10″ Single System": {
        link: "/products/mwf-wh101-single-filtration-system-11",
        img: "https://www.micronwaterfilters.com.au/cdn/shop/files/707654f8-0ff0-4a1f-b873-d876e4ffbb1f.jpg?v=1765511400",
        text: "",
        details: {
        intro: "10″ Single System whole house filtration systems provide simple sediment filtration for mains water, reducing sand, rust, silt and fine particles to improve water quality and protect plumbing throughout the home or business.",
         features: [
            ]
        }
    },
    "10″ Twin System": {
        link: "/products/mwf-wh102-twin-filtration-system-11",
        img: "https://www.micronwaterfilters.com.au/cdn/shop/files/131e75e8-b35a-4239-9fc9-83c160b0948a.jpg?v=1765511401",
        text: "",
        details: {
        intro: "10″ Twin System whole house filtration systems provide general purpose mains water filtration, reducing sediment, chlorine and odour to improve water quality at every tap while protecting plumbing and appliances throughout the home or business.",
         features: [
            ]
        }
    },
    "10″ Triple System": {
        link: "/products/mwf-wh103-triple-filtration-system-11",
        img: "https://www.micronwaterfilters.com.au/cdn/shop/files/7102e633-7c72-46a6-abf1-6c22e3b67a28.jpg?v=1765511400",
        text: "",
        details: {
        intro: "10″ Triple System whole house filtration systems provide multi stage mains water filtration, reducing sediment, chlorine and impurities to deliver cleaner, better quality water for showers, appliances and every tap in the home.",
         features: [
            ]
        }
    },
    "Shower Filter": {
        link: "https://www.micronwaterfilters.com.au/collections/shower-filter-accessories?_pos=1&_psq=shower+filter&_ss=e&_v=1.0",
        img: "https://cdn.shopify.com/s/files/1/0571/9254/6444/files/Shower_Filter.png?v=1769132350",
        text: "",
        details: {
        intro: "Complete shower filtration solution including the Micron Universal Shower Filter, replacement filter, and adapter for easy installation and ongoing performance.",
         features: [
            ]
        }
    },
    "Universal Shower Filter": {
        link: "https://www.micronwaterfilters.com.au/products/universal-shower-filter-brushed-silver?_pos=1&_psq=shower&_ss=e&_v=1.0",
        img: "https://cdn.shopify.com/s/files/1/0571/9254/6444/files/Micron_Water_Filter_Install_Explainer_M2509AL-05013.jpg?v=1769143212",
        text: "",
        details: {
        intro: "Micron Universal Shower Filter helps reduce impurities for cleaner water, supporting healthier skin and hair with every shower.",
         features: [
            ]
        }
    },
    "Shower Filter Accessories": {
        link: "https://www.micronwaterfilters.com.au/collections/shower-filter-accessories?_pos=1&_psq=shower+filter&_ss=e&_v=1.0",
        img: "https://cdn.shopify.com/s/files/1/0571/9254/6444/files/Shower_Filter_Accessories.png?v=1769132350",
        text: "",
        details: {
        intro: "Essential accessories for your shower filter, including replacement filters and adapters to keep your system working efficiently.",
         features: [
            ]
        }
    }
};

document.querySelectorAll('.menu-link.level-1 .menu_item-link').forEach(item => {
    item.addEventListener('mouseenter', () => {
        const span = item.querySelector('span');
        if (!span) return;

        const label = span.innerText.trim();
        const data = megaData[label];
        if (!data) return;

        const megaLink   = document.querySelector('.col-mega a');
        const megaImg    = document.querySelector('.col-mega img');
        const megaText   = document.querySelector('.col-mega .mega-text');
        const megaDetail = document.querySelector('.mega-details');

        if (megaLink) megaLink.href = data.link;
        if (megaImg) {
            megaImg.src = data.img;
            megaImg.srcset = data.img;
            megaImg.alt = label;
        }

        if (megaText) {
            megaText.textContent = data.text;
            megaText.parentElement.href = data.link;
        }

        // Render details (only if exists)
        if (megaDetail && data.details) {
            megaDetail.innerHTML = `
                <p>${data.details.intro}</p>
                <ul>
                    ${data.details.features.map(f => `<li>${f}</li>`).join('')}
                </ul>
            `;
        } else if (megaDetail) {
            megaDetail.innerHTML = '';
        }
    });
});
